import type { FunctionComponent, ReactNode, SVGProps } from 'react'

import { Typography } from '@gto/ui/typography'

export type FlipOutSectionTitleProps = {
  icon: FunctionComponent<SVGProps<SVGSVGElement>>
  title: ReactNode
  description?: ReactNode
}

export const FlipOutSectionTitle = ({
  icon: Icon,
  title,
  description,
}: FlipOutSectionTitleProps) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center text-primary-main">
          <Icon
            height={42}
            width={42}
          />
        </div>
        <Typography variant="h5">{title}</Typography>
      </div>
      {description !== undefined && (
        <Typography
          color="text.secondary"
          variant="body1"
        >
          {description}
        </Typography>
      )}
    </div>
  )
}
